// Utility functions for managing bank information in localStorage

const BANK_STORAGE_KEY = 'teklif_bank_info';

/**
 * Save bank information to localStorage
 * @param {Object} bankInfo - Bank information object
 */
export const saveBankInfoToStorage = (bankInfo) => {
  try {
    localStorage.setItem(BANK_STORAGE_KEY, JSON.stringify(bankInfo));
    return true;
  } catch (error) {
    console.error('Error saving bank info to localStorage:', error);
    if (error.name === 'QuotaExceededError') {
      alert('Storage quota exceeded. Please clear some data.');
    }
    return false;
  }
};

/**
 * Get bank information from localStorage
 * @returns {Object|null} Bank information object or null
 */
export const getBankInfoFromStorage = () => {
  try {
    const bankInfo = localStorage.getItem(BANK_STORAGE_KEY);
    return bankInfo ? JSON.parse(bankInfo) : null;
  } catch (error) {
    console.error('Error getting bank info from localStorage:', error);
    return null;
  }
};

/**
 * Remove bank information from localStorage
 */
export const removeBankInfoFromStorage = () => {
  try {
    localStorage.removeItem(BANK_STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error removing bank info from localStorage:', error);
    return false;
  }
};
